// extracted by mini-css-extract-plugin
module.exports = {"container":"CardStyles_container__17g2D"};